import React, { useCallback } from "react";
import { Button, CircularProgress } from "@mui/material";
import "../Button/button.scss";

export const CustomButton = React.memo(
  ({
    children,
    className = "",
    variant = "contained",
    color = "primary",
    size = "medium",
    fullWidth = false,
    disabled = false,
    startIcon,
    endIcon,
    onClick = () => {},
    type = "button",
    loading = false,
    loadingText = "Loading...",
    loadingPosition = "center", // 'start', 'center', or 'end'
    loadingIndicator = <CircularProgress size={20} color="inherit" />,
    ...props
  }) => {
    const getButtonContent = useCallback(() => {
      if (!loading) {
        return (
          <>
            {startIcon && (
              <span className="button-icon start-icon">{startIcon}</span>
            )}
            <span className="button-text">{children}</span>
            {endIcon && <span className="button-icon end-icon">{endIcon}</span>}
          </>
        );
      }

      switch (loadingPosition) {
        case "start":
          return (
            <div className="button-content">
              {loadingIndicator}
              <span className="loading-text">{loadingText}</span>
            </div>
          );
        case "end":
          return (
            <div className="button-content">
              <span className="loading-text">{loadingText}</span>
              {loadingIndicator}
            </div>
          );
        default: // center
          return <div className="button-content">{loadingIndicator}</div>;
      }
    }, [loading, loadingPosition, loadingIndicator, loadingText]);

    return (
      <Button
        className={`custom-button ${loading ? "loading" : ""} ${className}`}
        variant={variant}
        color={color}
        size={size}
        fullWidth={fullWidth}
        disabled={disabled || loading}
        onClick={onClick}
        type={type}
        {...props}
      >
        {getButtonContent()}
      </Button>
    );
  }
);
